import React, { useState, useEffect, useContext } from "react";
import ProfileForm from "../components/Profile/ProfileForm";
import ProfileGrid from "../components/Profile/ProfileGrid";
import "../styles/user.css";
import "../styles/home.css"
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";
import { UserContext } from "../context/UserContext";
import axios from "axios";

function ProfilePage() {
  const defaultUser = {
    username: "",
    fullName: "",
    email: "",
    bio: "",
    pic: "",
    resume: "",
    skills: [],
    github: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    devto: "",
  };
  const [curUser, setCurUser] = useState(defaultUser);
  const { user, setUser } = useContext(UserContext);
  const [closeForm, setCloseForm] = useState(true);

  useEffect(() => {
    axios
      .get("api/user/", {
        headers: {
          "x-auth-token": localStorage.getItem("user"),
        },
      })
      .then((res) => {
        console.log(res.data);
        setCurUser(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {}, [closeForm]);

  return (
    <>
      <SlideDown closed={closeForm}>
        <div className="userForm">
          <span
            className="closeFormBtn"
            onClick={(e) => {
              e.preventDefault();
              setCloseForm(!closeForm);
            }}
          >
            X
          </span>

          <div className="form">
            <ProfileForm
              curUser={curUser}
              setCurUser={setCurUser}
              setCloseForm={setCloseForm}
              closeForm={closeForm}
              defaultUser={defaultUser}
            />
          </div>
        </div>
      </SlideDown>

      {closeForm && (
        <>
          <ProfileGrid
            curUser={curUser}
            setCurUser={setCurUser}
            setCloseForm={setCloseForm}
            closeForm={closeForm}
            defaultUser={defaultUser}
          />
        </>
      )}
    </>
  );
}

export default ProfilePage;
